<template>
    <drawer-layout>
        <main class="bible">
            <data-gathering-header
                :title="$t('data_gatherings.surveys').toString()"
                :breadcrumbs-items="breadcrumbsItems"
            />

            <data-gathering-card-list />
        </main>
    </drawer-layout>
</template>

<script>
import IndexPage from "@/Pages/DataGathering/IndexPage";
import {i18n} from "@/i18n";
import DataGatheringHeader from "@/Shared/DathaGatherings/Common/DataGatheringHeader";

export default {
    components: {DataGatheringHeader},

    mixins: [IndexPage],

    props: {

    },

    data() {
        return {
            breadcrumbsItems: [
                {
                    text: i18n.t('data_gatherings.data_sources'),
                    disabled: true,
                },
                {
                    text: i18n.t('data_gatherings.surveys'),
                    disabled: true,
                    href: route('surveys.index'),
                },
            ],
        }
    },

    mounted() {
        this.setCommonRoute('explore_records', 'surveys.records');
    },
};
</script>

<style scoped>

</style>
